import * as React from 'react';

function SvgBaseball(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="16px" viewBox="4 4 16 16" width="16px" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M17.5 4a2.503 2.503 0 011.538 4.472L7.58 17.892c.084.189.128.395.128.609 0 .401-.157.777-.44 1.061-.283.282-.66.438-1.06.438-.35 0-.682-.12-.95-.339l-.111-.1-.707-.707c-.284-.284-.44-.661-.44-1.062s.157-.777.44-1.061c.432-.43 1.111-.533 1.66-.305L15.528 4.96a.268.268 0 01.035-.048A2.502 2.502 0 0117.5 4zM5.147 17.44a.494.494 0 000 .706l.707.708a.51.51 0 00.707 0 .496.496 0 000-.707l-.707-.707a.512.512 0 00-.707 0zm3.296-2.289L6.88 17.052l.067.067 1.901-1.563-.405-.405zM17.5 5c-.436 0-.844.184-1.129.507l-.031.042-7.259 8.826.543.543 8.827-7.258.042-.031A1.502 1.502 0 0017.5 5zM6 4c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0 1c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .551 0 1-.449 1-1 0-.551-.449-1-1-1z"
        fill="#2c8feb"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgBaseball;
